// Fixes passed to DarkReader when dark mode is turned on.
// DarkReader darkens every colour in our stylesheets, but injects `css` here unchanged,
// so colours that must stay light in dark mode belong here, not in the .scss files.
export const DARK_MODE_FIXES = {
    invert: [],
    ignoreInlineStyle: [],
    ignoreImageAnalysis: [],
    disableStyleSheetsProxy: false,
    css: `
        /* di-slider-toggle off state: ng-zorro's translucent black track turns black in dark mode */
        di-slider-toggle .ant-switch:not(.ant-switch-checked) {
            background-color: #bfbfbf !important;
        }
    `
};
